import { createContext, useContext, useEffect, useState } from "react";
import { useApi } from "@/lib/api";

const MeContext = createContext(null);

export function MeProvider({ children }) {
  const api = useApi();
  const [me, setMe] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    api("get", "/me").then(setMe).catch(() => setError(true));
  }, [api]);

  if (error) return <p className="p-8 text-sm text-stone-600" data-testid="me-error">Impossible de charger votre profil. Rechargez la page.</p>;
  if (!me) return <div className="min-h-screen grid place-items-center text-sm text-stone-500" data-testid="me-loading">Chargement…</div>;
  return <MeContext.Provider value={me}>{children}</MeContext.Provider>;
}

export const useMe = () => useContext(MeContext);
export const can = (me, perm) => me?.permissions?.includes(perm);
